module.exports = __webpack_public_path__ + "img/slider-arrow-right.f8a883b5.svg";